import store from '@/state/store'
export default [
  {
    path: '/',
    name: 'home',
    meta: {
      page: 1,
    },
    component: () => import('./views/customer/CustomerType.vue'),
    beforeEnter: (to, from, next) => {
      if (to.query.portal || store.state.portal) {
        return next({
          name: 'products-list',
        })
      } else return next()
    },
  },
  {
    path: '/business-lookup',
    name: 'business lookup',
    meta: {
      page: 2,
      back: '/',
    },
    component: () => import('./views/customer/BusinessLookup.vue'),
    beforeEnter: (to, from, next) => {
      if (store.state.portal) {
        next({
          name: 'products-list',
        })
      } else return next()
    },
  },
  {
    path: '/business-activities',
    name: 'business activities',
    meta: {
      page: 3,
      back: '/',
    },
    component: () => import('./views/customer/BusinessActivities.vue'),
    beforeEnter: (to, from, next) => {
      if (store.state.portal) {
        next({
          name: 'products-list',
        })
      } else return next()
    },
  },
  {
    path: '/turnover',
    name: 'turnover',
    meta: {
      page: 4,
      back: '/business-activities',
    },
    component: () => import('./views/customer/Turnover.vue'),
    beforeEnter: (to, from, next) => {
      if (store.state.portal) {
        next({
          name: 'products-list',
        })
      } else return next()
    },
  },
  // {
  //   path: '/turnover-jurisdiction',
  //   name: 'turnover jurisdiction',
  //   meta: {
  //     page: 5,
  //     back: '/turnover',
  //   },
  //   component: () => import('./views/customer/TurnoverJurisdiction.vue'),
  // },
  {
    path: '/employees',
    name: 'employee count',
    meta: {
      page: 6,
      back: '/turnover',
    },
    component: () => import('./views/customer/Employees.vue'),
  },
  {
    path: '/personal-details',
    name: 'personal details',
    meta: {
      page: 7,
      back: '/employees',
    },
    component: () => import('./views/customer/PersonalDetails.vue'),
  },
  {
    path: '/products',
    name: 'products-list',
    meta: {
      page: 8,
      back: '/personal-details',
      title: 'Build your subscription',
      tagline: 'Choose from the options below',
    },
    component: () => import('./views/product/List.vue'),
  },
  {
    path: '/products/start',
    name: 'products-list-start',
    meta: {
      page: 8,
      back: '/personal-details',
      title: 'Build your subscription',
      tagline: 'Choose from the options below',
    },
    component: () => import('./views/product/List.vue'),
  },
  {
    path: '/products/:id/info',
    name: 'product-info',
    meta: {
      noTitle: true,
      page: 9,
    },
    component: () => import('./views/product/Info.vue'),
    props: true,
  },
  {
    path: '/products/:id/config',
    name: 'product-config',
    meta: {
      noTagline: true,
      page: 10,
      back: '/products',
    },
    component: () => import('./views/product/Config.vue'),
  },
  {
    path: '/overview',
    name: 'quote overview',
    meta: {
      page: 11,
      back: '/products',
      title: 'Build your subscription',
      tagline: 'Review your details',
    },
    component: () => import('./views/overview/Overview.vue'),
  },
  {
    path: '/statements/:id',
    name: 'statement',
    meta: {
      page: 12,
      title: `Do you agree with these details?`,
    },
    component: () => import('./views/Statement.vue'),
  },
  {
    path: '/quote-confirmation',
    name: 'quote confirmation',
    props: {
      isConfirmation: true,
    },
    meta: {
      page: 13,
      title: "Here's your quote",
    },
    component: () => import('./views/overview/Overview.vue'),
  },
  {
    path: '/checkout/personal',
    name: 'checkout personal details',
    meta: {
      page: 14,
      back: '/quote-confirmation',
      title: "Let's get you set up",
      noTagline: true,
    },
    component: () => import('./views/customer/PersonalDetails.vue'),
  },
  {
    path: '/checkout/policyholder',
    name: 'policy holder details',
    meta: {
      page: 15,
      back: '/checkout/personal',
      title: "Let's get you set up",
      noTagline: true,
    },
    component: () => import('./views/checkout/PolicyholderDetails.vue'),
  },
  {
    path: '/checkout/address',
    name: 'address lookup',
    meta: {
      page: 16,
      back: '/checkout/policyholder',
      title: "Let's get you set up",
      noTagline: true,
    },
    component: () => import('./views/checkout/AddressLookup.vue'),
  },
  {
    path: '/checkout/policy-start-date',
    name: 'policy start date',
    meta: {
      page: 17,
      title: "Let's get you set up",
      back: '/checkout/policyholder',
      tagline: 'Choose your start date',
    },
    component: () => import('./views/PolicyStartDate.vue'),
  },
  {
    path: '/checkout/payment',
    name: 'billing details',
    meta: {
      page: 18,
      back: '/checkout/policy-start-date',
      title: 'Set up your payment',
      noTagline: true,
    },
    component: () => import('./views/checkout/BillingDetails.vue'),
  },
  {
    path: '/success',
    name: 'quote-successful',
    meta: {
      page: 19,
      noTitle: true,
    },
    component: () => import('./views/Success.vue'),
  },
  {
    path: 'login/starling2',
    name: 'login starling',
    redirect: (routeTo) => {
      return {
        path: 'login/starling',
        query: routeTo.query,
      }
    },
  },
  {
    path: '/login/:partnerId', // partnerId setup for future
    name: 'user-login',
    meta: {
      page: 30,
      noTitle: true,
    },
    component: () => import('./views/user/LoginRegister/Starling'),
  },
  {
    path: '/user/profile',
    name: 'user-profile',
    meta: {
      page: 30,
      noTitle: true,
    },
    component: () => import('./views/user/Profile.vue'),
  },
  {
    path: '/user/reset-password',
    name: 'user-reset-password',
    meta: {
      page: 30,
      noTitle: true,
    },
    component: () => import('./views/user/ResetPassword.vue'),
  },
  {
    path: '/user/management',
    name: 'user-management',
    meta: {
      page: 30,
      noTitle: true,
    },
    component: () => import('./views/user/Management.vue'),
  },
  {
    path: '/404',
    name: 'error-page',
    meta: {
      noTagline: true,
      noTitle: true,
      page: 20,
    },
    component: () => import('./views/Error.vue'),
  },
  {
    path: '/refer-quote',
    name: 'refer-quote',
    meta: {
      noTagline: true,
      noTitle: true,
      page: 21,
    },
    component: () => import('./views/ReferQuote.vue'),
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
// function lazyLoadView(AsyncView) {
//   const AsyncHandler = () => ({
//     component: AsyncView,
//     // A component to use while the component is loading.
//     loading: require('./views/_loading').default,
//     // Delay before showing the loading component.
//     // Default: 200 (milliseconds).
//     delay: 400,
//     // A fallback component in case the timeout is exceeded
//     // when loading the component.
//     error: require('./views/_timeout').default,
//     // Time before giving up trying to load the component.
//     // Default: Infinity (milliseconds).
//     timeout: 10000,
//   })
//
//   return Promise.resolve({
//     functional: true,
//     render(h, { data, children }) {
//       // Transparently pass any props or children
//       // to the view component.
//       return h(AsyncHandler, data, children)
//     },
//   })
// }
